import { AnalyticsBrowser } from '@segment/analytics-next'

import { SEGMENT_WRITE_KEY } from 'constants/app.constants'

export const analytics = AnalyticsBrowser.load({
  writeKey: SEGMENT_WRITE_KEY || '',
})
